"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.LinkGroup = void 0;
/** @prettier */
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var R = __importStar(require("ramda"));
var Icons_1 = require("./Icons");
var LinkGroup = /** @class */ (function (_super) {
    __extends(LinkGroup, _super);
    function LinkGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            sideNavState: _this.props.collapsed
        };
        return _this;
    }
    LinkGroup.prototype.componentWillReceiveProps = function (nextProps) {
        if (!nextProps.expanded) {
            this.setState({ sideNavState: nextProps.collapsed });
        }
        if (nextProps.collapsed !== this.props.collapsed && !this.props.collapsed) {
            this.props.onClick(false, this.props.label);
        }
    };
    LinkGroup.prototype.render = function () {
        var _this = this;
        var classes = "".concat(this.props.className || '', " vs-sidenav-entry vs-sidenav-container") +
            (this.props.expanded && !this.props.collapsed ? ' expanded' : '');
        var expandRow = function () {
            _this.props.onClick(!_this.props.expanded, _this.props.label);
            if (_this.props.expanded) {
                _this.props.toggleSideNav(_this.state.sideNavState);
            }
            else {
                _this.props.toggleSideNav(_this.props.expanded);
            }
        };
        var icon = !R.isNil(this.props.svgIcon) ? (react_1["default"].createElement(Icons_1.SideNavSvgIcon, null, this.props.svgIcon)) : !R.isNil(this.props.icon) ? (this.props.icon) : ((0, Icons_1.makeDefaultIcon)(this.props.label));
        return (react_1["default"].createElement("li", { className: classes },
            react_1["default"].createElement("a", { className: "vs-sidenav-container-row", onClick: expandRow, title: this.props.label },
                react_1["default"].createElement("div", { className: "vs-sidenav-container-row-left" },
                    icon,
                    react_1["default"].createElement("span", { className: "vs-sidenav-container-label" }, this.props.label)),
                react_1["default"].createElement("i", { className: "fa fa-chevron-right vs-sidenav-container-chevron" })),
            react_1["default"].createElement("ul", { className: "vs-link-group-children" }, this.props.children)));
    };
    return LinkGroup;
}(react_1["default"].Component));
exports.LinkGroup = LinkGroup;
LinkGroup.propTypes = {
    expanded: prop_types_1["default"].bool,
    onClick: prop_types_1["default"].func.isRequired,
    label: prop_types_1["default"].string.isRequired,
    toggleSideNav: prop_types_1["default"].func.isRequired
};
